import * as z from 'zod'

export const IdSchema = z.coerce.number().int().nonnegative()

export type IdSchema = z.input<typeof IdSchema>

export const isNumericId = (value: unknown) => IdSchema.safeParse(value).success
